import { Component, OnInit } from '@angular/core';
import { GlobalFilterService } from 'src/app/shared/services/filters/global-filter.service';
import * as _ from 'lodash';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-active-filters-chips',
    templateUrl: './active-filters-chips.component.html',
    styleUrl: './active-filters-chips.component.scss',
    imports: [NgIf]
})
export class ActiveFiltersChipsComponent implements OnInit {
  isActiveFiltersEnabled: boolean = false;
  isHierarchFilterActive: boolean = false;
  isUniversalFilterActive: boolean = false
  activeUniversalFilter: any = {
    question_filter: false,
    text_filter: false,
    transaction_filter: false,
    action_filter: false
  }
  isAddfilterBtnEnabled: boolean = true;
  isAccount: boolean = false;
  accountId: string = '';
  projectId: string = '';
  activeTab: string = '';
  isHierarchFilterHidden:boolean = false

  isCohortAccessAvailable:boolean=false;
  isOtherTagFilterAvailable:boolean = false;
  constructor(
    private _filterService: GlobalFilterService,
    private _helpers: HelpersService,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit(): void {
    this._filterService.globalFilterState$.subscribe(() => {
      this.updateActiveFilters()
    })
    this._filterService.hideHierarchyFilter.subscribe((flag)=>{
      this.isHierarchFilterHidden = (flag == true)?true:false;
      this.updateActiveFilters()
    })
    this._route.queryParams.subscribe(params => {
      let url = this._router.url
      let activeTab = params['active_tab']
      let accountId = params['account_id'];
      let projectId = params['project_id']
      this.isAccount = (_.isNull(projectId) || !projectId) ? true : false;
      let routeData = this._helpers.prepareRouteData(url)
      if (this.accountId != accountId || this.projectId != projectId || this.activeTab != activeTab) {
        this.updateFilterVisiblity(routeData)
      }
    });
  }
  
  updateActiveFilters() {
    this.isCohortAccessAvailable = false;
    this.isOtherTagFilterAvailable = false;
    this.isActiveFiltersEnabled = false;
    this.isUniversalFilterActive = false;
    this.activeUniversalFilter = {
      question_filter: false,
      text_filter: false, 
      transaction_filter: false,
      action_filter: false
    }
    let global_filter_data = this._filterService.getAppliedFilters();
    let univeralFilters = this._filterService.getUniveralFilters()
    // Draw active default access or Applied filter
    if ((global_filter_data && global_filter_data['by_hierarchy_drilldown']) || (global_filter_data && global_filter_data['by_hierarchy_level_and_value'])) {
      let hiearchyFilter = (global_filter_data['by_hierarchy_drilldown']) ? global_filter_data['by_hierarchy_drilldown'] : global_filter_data['by_hierarchy_level_and_value'];
      
      if (hiearchyFilter && hiearchyFilter.length > 1) {
        const hierarchyLevel2 = hiearchyFilter[1];
        if (hierarchyLevel2 && hierarchyLevel2.value != 'All' && hierarchyLevel2.value != "ALL") {
          this.isHierarchFilterActive = true;
        } else {
          this.isHierarchFilterActive = false; 
        }
      } else if('by_hierarchy_level_and_value' in global_filter_data &&  hiearchyFilter &&  hiearchyFilter.value != 'All' && hiearchyFilter.value != 'ALL'){
        this.isHierarchFilterActive = true;
      }else{
        this.isHierarchFilterActive = false;
      }
    }
    if (this.isHierarchFilterActive) {
      this.isActiveFiltersEnabled = true;
    }

    if (univeralFilters && univeralFilters.filters && univeralFilters.filters.length) {
      _.each(univeralFilters.filters, (object: any) => {
        if (object.filterType == "question_filter") {
          this.activeUniversalFilter.question_filter = true;
        }
        if (object.filterType == "text_filter") {
          this.activeUniversalFilter.text_filter = true;
        }
        if (object.filterType == "transaction_filter") {
          this.activeUniversalFilter.transaction_filter = true;
          if(object.isAccessLevelFilter == true){
            this.isCohortAccessAvailable = true;
          }else{
            this.isOtherTagFilterAvailable = true;
          }
        }
        if (object.filterType == "action_filter") {
          this.activeUniversalFilter.action_filter = true;
        }
      })
      this.isUniversalFilterActive = true;
      this.isActiveFiltersEnabled = true;
    }
    if(this.isHierarchFilterHidden && !this.isUniversalFilterActive){
      this.isActiveFiltersEnabled = false;
    }
  }

  updateFilterVisiblity(routeData: any) {
    const hideFilterOnRotue = ['engagement','outbox','huddle'];
    const hideFilterOnTab = ['quickinsights']

    if (hideFilterOnRotue.indexOf(routeData.routeName) >= 0 || hideFilterOnTab.indexOf(routeData.active_tab) >= 0) {
      this.isAddfilterBtnEnabled = false;
    } else {
      this.isAddfilterBtnEnabled = true;
    }
  }

  clearActiveFilters(event: any, filterType: string) {
    event.stopPropagation();
    let univeralFilters = this._filterService.getUniveralFilters()
    univeralFilters.filters = _.filter(univeralFilters.filters, (filter: any) => {
      if(this.isCohortAccessAvailable){
        return ((filter.filterType == filterType && filter.isAccessLevelFilter == true) || (filter.filterType != filterType))
      }else{
        return (filter.filterType != filterType)
      }
    })
    delete univeralFilters.filterId
    const formatedFilters = this._filterService.getFormatedUniversalFilter(univeralFilters.filters);
    this._filterService.storeUniversalFilters(univeralFilters);
    this._helpers.setUniversalFilters(formatedFilters);
  }
  openGlobalFilterSideBar(event: any, filterType: string) {
    if (event) event.stopPropagation();

    this.renderGlobalFilter(filterType)

    // }
  }

  renderGlobalFilter(filterType: string) {
    const tabs = ["question_filter", "text_filter", "transaction_filter", "action_filter"];
    let tabData: any = {};
    // Special handling for hierarchy filter
    if (filterType === "hierarchy") {
      tabData = {
        tabName: "by_hierarchy",
        filterType: filterType,
        isHierarchyFilter: true
      };
      // Get current hierarchy filter state
      const globalFilterData = this._filterService.getAppliedFilters();
      if (globalFilterData) {
        tabData.appliedFilterData = {
          by_hierarchy_drilldown: globalFilterData.by_hierarchy_drilldown,
          by_hierarchy_level_and_value: globalFilterData.by_hierarchy_level_and_value
        };
      }
    } else {
      // Handle other filter types
      tabData = {
        tabName: tabs.includes(filterType) ? "active_filter" : "by_dimension",
        filterType: filterType
      };
      // Fetch latest applied filters for non-hierarchy filters
      const currentFilters = this._filterService.getUniveralFilters();
      if (currentFilters && currentFilters.filters && currentFilters.filters.length) {
        tabData.appliedFilterData = currentFilters.filters.filter(f => f.filterType === filterType);
      }
    }

    // Update the filter panel state
    this._filterService.openGlobalFilterPanel(tabData);

  }
}
